import base64 from 'base-64';
import utf8 from 'utf8';

export const EncodeData = (dataToBeEncoded: string) => {
    return base64.encode(utf8.encode((dataToBeEncoded)));
};

export const DecodeData = (dataToBeDecoded: string) => {
    return base64.decode(utf8.decode((dataToBeDecoded)));
};